import React from 'react';
import PropTypes from 'prop-types';

const SecondarySection = (props) => (
    <section
        className="sb-filter__section__wrapper"
        style={{
            display: 'flex',
            flexWrap: 'wrap',
        }}
    >
            {props.sectionName && <h4 className="sb-filter__header__advanced__label">
                {props.sectionName}
            </h4>}
            {props.children}
    </section>
);

SecondarySection.propTypes = {
    sectionName: PropTypes.string,
    children: PropTypes.node.isRequired
};

export default SecondarySection;



// WEBPACK FOOTER //
// ./src/client/components/SecondarySection.js